import axios from "axios";
import { Country } from "../../utils/database";
import { BACKEND_URL } from "../../config/api";


export const countriesService = {
  async createCountry(newCountry: Country) {
    try {
      await axios.post(`${BACKEND_URL}/country/`, newCountry);
    } catch (error) {
      throw error;
    }
  },
  async getCountries(limit: any, skip: any): Promise<Country[]> {
    try {
      const response = await axios.get(`${BACKEND_URL}/country/?skip=${skip}&limit=${limit}`);

      const data = response.data;

      return data.data.countries;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
   async getCountryById(countryId: any): Promise<Country> {
    try {
      const response = await axios.get(`${BACKEND_URL}/country/${countryId}`);

      const data = response.data;

      return data.data.country;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async updateCountry(newData: Country) {
    try {
      await axios.put(`${BACKEND_URL}/country/${newData.id}`, newData);
    } catch (error) {
      console.error(error);
    }
  },
  async deleteCountry(country_id: string) {
    try {
      await axios.delete(`${BACKEND_URL}/country/${country_id}`);
    } catch (error) {
      console.error(error);
    }
  },
};
